<template>
    <v-container >
        <v-row class="d-none">
            <v-col 
                v-for="(content, i) in data.contents" 
                :key="i"
                :class="content.class"
                :cols="(content.cols.mobile) ? content.cols.mobile : 12"
                :md="(content.cols.tablet) ? content.cols.tablet  : 12"
                :lg="(content.cols.desktop) ? content.cols.desktop  : 12"
            >
               <pre>{{  content }}</pre>
            </v-col>
        </v-row>
        <Contents :contents="data.contents"></Contents>
    </v-container>
</template>
<script setup>
import Contents from '../Contents.vue';
</script>
<script>
export default {
    props:{
        data:{
            required: true,
            type: Object,
        }
    },
}
</script>